import { useContext } from "react";
import { Button } from "../Button/Button";
import { AosContext } from "../Context/AosContext";
import { HeroWrapper } from "./Hero.elements";

const Hero = () => {
  const delay = useContext(AosContext);

  return (
    <HeroWrapper>
      <div className="res-cnt">
        <h1 data-aos="fade-left" data-aos-delay={delay}>
          Reciklirajte
          <br />
          za bolji dom
        </h1>
        <h3 data-aos="fade-left" data-aos-delay={delay * 2}>
          Prva fabrika reciklaze stakla u Srbiji
        </h3>
        <Button primary data-aos="fade-up" data-aos-delay={delay * 3}>
          Kontakt
        </Button>
        <Button data-aos="fade-up" data-aos-delay={delay * 4}>
          Prodavnica
        </Button>
      </div>
    </HeroWrapper>
  );
};

export default Hero;
